<template>
	<div class="tkod-main">
		<yj-progress-edit :statusList="statusList" :currentStatus="orderStatus" />
		<el-card class="textLeft marTop20">
			<el-row type="flex" justify="space-between" style="margin-bottom: 10px">
				<el-col class="flex-column" :span="9">
					<p>原订单号：{{ hotelRefundDetail.orderNo }}</p>
					<p style="margin-left: 20px;" v-if="$route.query.orderRefundNo">退单单号：{{ $route.query.orderRefundNo }}</p>
				</el-col>
				<el-col class="flex-column text-right" :span="3">
					<p>
						{{ hotelRefundDetail.htRefundStatusRemark }}
					</p>
				</el-col>
			</el-row>
			<div v-if="hotelRefundDetail.spgzId && hotelRefundDetail.vipStatus > 0"
				style="padding:20px 0 20px 40px;border: 1px solid #e6e6e6;margin-bottom: 10px;">
				<yj-approval-progress :orderId="hotelRefundDetail.htRefundId" :orderType="orderType"
					:resetspjd="resetspjd"></yj-approval-progress>
			</div>
			<div class="tk-main">
				<div class="left-main-width">
					基本信息
				</div>
				<el-row class="left-main-right">
					<el-col class="flex-column" v-if="hotelRefundDetail.supplierName" :span="6">
						<div>
							服务商：{{ hotelRefundDetail.supplierCode }}{{ hotelRefundDetail.supplierName }}
						</div>
					</el-col>
					<el-col class="flex-column" :span="6">
						<div>
							退房原因：{{ hotelRefundDetail.vipRefundReason }}
						</div>
					</el-col>
					<el-col class="flex-column" :span="6">
						<div>
							应退金额：<span style="color:#f5a337 ;font-size:22px">￥{{ hotelRefundDetail.cuRefundAmount }}</span>
						</div>
					</el-col>
					<el-col class="flex-column" :span="6">
						<div>
							<!-- 支付方式:{{ hotelRefundDetail.payMothedName }} -->
						</div>
					</el-col>
				</el-row>
			</div>
			<div class="tk-main">
				<div class="left-main-width">退房信息</div>
				<div class="rooms-right">
					<el-row class="romms-info">
						<el-col class="flex-column" :span="12">
							<div>
								原预订信息：{{ hotelRefundDetail.jdmc }} {{ hotelRefundDetail.fxmc }} {{ hotelRefundDetail.rooms }} 间
								{{ hotelRefundDetail.nights }} 晚
							</div>
						</el-col>
						<el-col class="flex-column" :span="6">
							<div>
								原订单合计：<span style="color:#f5a337 ;font-size:22px">￥{{ hotelRefundDetail.xsj }}</span>
							</div>
						</el-col>
					</el-row>
					<div style="padding: 10px 0;">
						<div v-for="(item, index) in hotelRefundDetail.roomList" :key="index"
							style="padding: 5px 0 5px 40px;text-align: left;width:996px;">
							<span style="display: inline-block;text-align: left;width:30%;">
								入住人:{{ item.custName }}
							</span>
							<span style="display: inline-block;text-align: left;width:30%;">
								退订房间:{{ item.roomNo }}号
							</span>
							<span style="display: inline-block;text-align: left;width:30%;">
								退订日期:{{ item.daysDesc }} 共 {{ item.nightNum }} 晚
							</span>
						</div>
					</div>
					<!-- <el-row> -->

					<!-- <el-col class="flex-column" :span="8"
							><div>
								入住人:{{ hotelRefundDetail.psgName}}
							</div></el-col
						>
						<el-col class="flex-column" :span="8"
							><div>
								退订房间:退{{ hotelRefundDetail.fxmc}} {{hotelRefundDetail.htRefundRooms}}间
							</div></el-col
						>
						<el-col class="flex-column" :span="8"
							><div>
								退订日期:{{ hotelRefundDetail.htRefundDays}} 共 {{hotelRefundDetail.htRefundNights}} 晚
							</div></el-col
						> -->
					<!-- </el-row> -->
				</div>
			</div>
			<el-row type="flex" justify="center" class="left-main-right b-t-1" style="padding-top: 10px">
				<el-button class="padButton" @click="close">关 闭</el-button>
				<el-button class="padButton" v-if="hotelRefundDetail.isShowApproval == 1"
					@click="sendApp(hotelRefundDetail)">送审</el-button>
				<el-button class="padButton" v-if="hotelRefundDetail.isShowCancelApprove == 1"
					@click="orderCaoZuo(hotelRefundDetail)">撤回</el-button>
			</el-row>
		</el-card>
	</div>
</template>

<script>

import caozuoMixin from '@/mixin/models/caozuoMixin.js';

export default {
	name: 'tkOrderDetail',
	mixins: [caozuoMixin.commonConfig],
	data() {
		return {
			statusList: [],
			currentStatus: 1,
			orderId: '', //订单id
			orderType: 11008, // 订单类型
			orderStatus: '',
			hotelRefundDetail: '', //订单信息
			hotelRefundInfo: '', //退订信息
			everyPriceList: [],
			orderIdRes: '', //酒店退订拿到的退订id，借此获取酒店id
			resetspjd: false,
		}
	},

	computed: {},
	mounted() {

		this.orderId = this.$route.query.orderId
		this.getHtRefundDetail(),
			this.getAppProgress()
	},
	methods: {

		getStatus() {
			let vipStatus = this.hotelRefundDetail.vipStatus;
			let zflx = this.hotelRefundDetail.zflx;
			// let orderStatus=this.hotelRefundDetail.orderStatus;
			let htRefundStatus = this.hotelRefundDetail.htRefundStatus
			//    willApproval("1","待送审"), //待送审
			// approvaling("2","审批中"), //审批中
			// willHandle("3","待办理"), //待办理
			// handling("4","办理中"), //办理中
			// refundRoom("5","已退房"),//已退票
			// refundMoney("6","已退款"),//已退票
			// refundCancel("7","已取消") //退票被取消
			if (vipStatus != '4') {
				this.statusList = [
					{ status: "1", name: '送审' },
					{ status: "2", name: '申请已提交' },
					{ status: "3", name: '办理中' },
					{ status: "4", name: '已退房' },
					{ status: "5", name: '已退款' },
				]
				if (htRefundStatus == 1 || htRefundStatus == 2) {
					this.orderStatus = 1
				} else if (htRefundStatus == 3) {
					this.orderStatus = 2
				} else if (htRefundStatus == 4) {
					this.orderStatus = 3
				} else if (htRefundStatus == 5) {
					this.orderStatus = 4
				} else if (htRefundStatus == 6) {
					this.orderStatus = 5
				} else if (htRefundStatus == 7) {
					this.orderStatus = 5
				}
			} else if (vipStatus == 4) {
				this.statusList = [
					{ status: "1", name: '申请已提交' },
					{ status: "2", name: '办理中' },
					{ status: "3", name: '已退房' },
					{ status: "4", name: '已退款' },
				]
				if (htRefundStatus == 3) {
					this.orderStatus = 1
				} else if (htRefundStatus == 4) {
					this.orderStatus = 2
				} else if (htRefundStatus == 5) {
					this.orderStatus = 3
				} else if (htRefundStatus == 6) {
					this.orderStatus = 4
				} else if (htRefundStatus == 7) {
					this.orderStatus = 0
				}
			}

		},
		//酒店退订详情
		getHtRefundDetail() {
			this.$conn
				.getConn('htRefund.htRefundDetail', { error: true })({
					hotelRefundId: this.$route.query.orderId,
				})
				.then((res) => {
					this.orderIdRes = res.data.orderId
					if (res.data.htRefundStatus == 3) {
						this.currentStatus = 1
					} else if (res.data.htRefundStatus == 4) {
						this.currentStatus = 2
					} else if (res.data.htRefundStatus == 5) {
						this.currentStatus = 3
					} else if (res.data.htRefundStatus == 6) {
						this.currentStatus = 4
					}
					let data = res.data || {};
					data.roomList = (data.roomList || []).map(item => {
						let refundDays = item.everyPriceList.filter(v => v.status != 0);
						let nightNum = refundDays.length;
						let daysDesc = refundDays.map(v => v.day).join(',');
						return {
							...item,
							nightNum,
							daysDesc
						}
					})
					this.hotelRefundDetail = data;
					this.resetspjd = !this.resetspjd;
					// console.log(this.hotelRefundDetail, "this.hotelRefundDetail")
					this.getStatus()
				})
		},
		sendApp(info) {
			var queryParams = {};
			queryParams = {
				orderId: info.htRefundId,
				orderType: this.orderType,
				spgzId: info.spgzId,
			};
			this.$confirm('您确定要送审吗?', '', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$conn.getConn('commu.sendApp')(queryParams, (res) => {
					this.$message({
						type: 'success',
						message: '送审成功'
					});
					this.getHtRefundDetail();
				}, (err) => {
					this.$message({
						type: 'error',
						message: err.tips
					});
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '关闭取消'
				});
			});
		},
		// 操作  16 撤回
		orderCaoZuo(info) {
			this.goToCancelApprove({
				orderId: info.htRefundId,
				orderType: this.orderType,
			}, (res) => {

				this.getHtRefundDetail();
			}, (err) => {

			})

		},
		// 关闭本页面
		close() {
			this.$confirm('此操作将关闭本页面, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					window.close()
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '取消关闭',
					})
				})
		},



		getAppProgress() {
			this.$conn
				.getConn('commu.appProgress', { jsfile: false })({
					orderId: this.orderId,
					orderType: this.orderType,
				})
				.then((res) => {
					console.log(res, 'res')
				})
		},
	},
}
</script>

<style scoped="scoped" lang="scss">
.padButton {
	padding: 10px 30px;
	font-size: 15px;
}

.text-right {
	justify-content: end;
}

.b-t-1 {
	border: none;
	border-top: 1px solid #e6e6e6;
}

.p-r-20 {
	padding-right: 20px;
}

.textLeft {
	text-align: left;
}

.marTop20 {
	margin-top: 20px;
}

.between {
	justify-content: space-between;
}

.flex-column {
	display: flex;
	justify-items: center;
}

.tkod-main {
	margin: 0 auto;
	width: 1200px;
	padding-top: 20px;
	padding-bottom: 50px;

	.tk-main {
		display: flex;
		margin-bottom: 10px;
		min-height: 80px;
		border: 1px solid #e6e6e6;
		box-sizing: border-box;

		.left-main-width {
			width: 160px;
			display: flex;
			justify-content: center;
			align-items: center;
			background: #fafafa;
			border-right: 1px solid #e6e6e6;
		}

		.left-main-right {
			flex: 1;
			padding-left: 40px;
			display: flex;
			align-items: center;
		}

		.rooms-right {
			flex: 1;
			width: 100%;
			flex-direction: column;
			display: flex;
			align-items: center;

			.romms-info {
				padding-left: 40px;
				border-bottom: 1px solid #e6e6e6;
				width: 100%;
				min-height: 80px;
				display: flex;
				// justify-content: center;
				align-items: center;
			}

			.romms-info:nth-child(2) {
				border-bottom: none;
				margin-bottom: 20px;
			}

			.romms-info:nth-child(3) {
				border-bottom: none;
			}
		}
	}

	.flex {
		display: flex;
	}
}
</style>
